import f3tch from 'f3tch';

import API_URL from '../../constants/url.constant.api';
import profile from '../../profiles/json.profile.api';

const listNotificationsApi = (query = {}) =>
  f3tch('/notifications')
    .profile(profile({url: API_URL()}))
    .query(query)
    .get();

export default listNotificationsApi;
